import { ChakraBox as Box } from "@airhelp/react-ui-components";
import type { AnchorProps } from "./Anchor.d";

const Anchor = ({ id }: AnchorProps) => <Box id={id} pos="relative" top={-24} />;

export default Anchor;
